import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React, { Component } from 'react';
import { I18nContext } from './context';
import { initSSR } from './utils';
export var I18nextProvider =
/*#__PURE__*/
function (_Component) {
  _inherits(I18nextProvider, _Component);

  function I18nextProvider(props) {
    var _this;

    _classCallCheck(this, I18nextProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(I18nextProvider).call(this, props)); // nextjs / SSR: getting data from next.js or other ssr stack

    initSSR(props, true);
    return _this;
  }

  _createClass(I18nextProvider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          i18n = _this$props.i18n,
          defaultNS = _this$props.defaultNS,
          reportNS = _this$props.reportNS;
      return React.createElement(I18nContext.Provider, {
        value: {
          i18n: i18n,
          defaultNS: defaultNS,
          reportNS: reportNS,
          lng: i18n && i18n.language,
          t: i18n && i18n.t.bind(i18n)
        }
      }, children);
    }
  }]);

  return I18nextProvider;
}(Component);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-i18next/dist/es/I18nextProvider.js
// module id = 1453
// module chunks = 0